import { ReactElement } from 'react'
import { formatAmountForDisplay } from '@/utils/stripe-helpers'
import { CURRENCY } from '@/config'
import NinjaIco from '@repo/ui/icons/ninja-ico'
import { TAX_INCLUDED_ITEM_LABEL } from '@/config/textos-fiscales'

export type ListPriceProps = {
  ninjaIconName?: string
  priceTitle: string
  priceSubTitle?: string
  price: number
  detail?: boolean
}

export function ListPriceItems({
  ninjaIconName,
  priceTitle,
  priceSubTitle,
  price,
  detail,
}: ListPriceProps): ReactElement {
  return (
    <div className={detail ? 'flex flex-row' : 'flex flex-col md:flex-row'}>
      <div className="w-full space-y-2">
        <div className="flex flex-row items-center">
          <NinjaIco className="hidden h-[30px] min-h-[30px] w-[30px] min-w-[30px] pr-2 md:block" />
          <p className="text-checkout-xl font-medium">{priceTitle}</p>
        </div>
        {priceSubTitle && (
          <p
            className={
              detail
                ? 'text-checkout-m text-checkout-bk-op40 font-normal'
                : 'text-checkout-m text-checkout-bk-op40 hidden font-normal md:block'
            }>
            {priceSubTitle}
          </p>
        )}
      </div>

      <div
        className={
          detail
            ? 'flex w-1/3 flex-col items-end space-y-2'
            : 'hidden w-1/3 flex-col items-center space-y-2 md:flex md:items-end'
        }>
        <p className="text-checkout-mxl font-medium">
          {formatAmountForDisplay(price, CURRENCY)}
        </p>
        <p
          className={
            detail
              ? 'text-checkout-s text-checkout-bk-op40 text-right font-normal'
              : 'text-checkout-s text-checkout-bk-op40 hidden text-right font-normal md:block'
          }>
          {TAX_INCLUDED_ITEM_LABEL}
        </p>
      </div>
    </div>
  )
}
